// Externals
import { useSelector } from 'react-redux';

// Libraries
import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { type SalesCheckinRootState } from '../common/types/SalesCheckinRootState';
import type { SalesCheckinAppState } from '../common/types/SalesCheckinAppState';

// Workflow

/**
 * Returns the current Showroom workflow status derived by the workflowEvaluator
 * and stored on the `workflow` slice. Defaults to `IDLE` when the slice has not
 * been populated yet (e.g. before bootstrap completes).
 */
export const getShowroomWorkflowStatus = (state: SalesCheckinRootState): WorkflowStatus =>
    (state.salesCheckin as SalesCheckinAppState)?.workflow?.status ?? WorkflowStatus.IDLE;

export const useShowroomWorkflowStatusSelector = (): WorkflowStatus => useSelector(getShowroomWorkflowStatus);

/**
 * Whether workflowEvaluatorMiddleware is permitted to re-evaluate WorkflowStatus.
 * Defaults to `true` when the slice has not been populated yet.
 */
export const canNavigateOnWorkflowChange = (state: SalesCheckinRootState): boolean =>
    (state.salesCheckin as SalesCheckinAppState)?.workflow?.shouldNavigateOnWorkflowChange ?? true;
